import BalanceTransfer from "../../components/walletReports/balanceTransfer";
/**
 * BalanceTransferPage
 *
 * صفحه انتقال موجودی کیف پول.
 * رندر کامپوننت BalanceTransfer که فرم و جدول تراکنش‌ها را برای انتقال موجودی نمایش می‌دهد.
 *
 * @returns JSX.Element
 */

// Task Response:

// کد درست است و به درستی کامپوننت BalanceTransfer را رندر می‌کند.
// می‌توان آن را به شکل کوتاه‌تر نوشت:
const BalanceTransferPage = () => <BalanceTransfer />;


export default BalanceTransferPage;
